import Konva from 'konva';
import { RefObject } from 'react';

export interface ImageData {
  konvaImage: Konva.Image;
  url: string;
}

interface IProps {
  layerRef: RefObject<Konva.Layer>;
  textsRef: React.MutableRefObject<Konva.Text[]>;
  imagesRef: React.MutableRefObject<ImageData[]>;
  textActive: number | null;
  imageActive: number | null;
}

const useZindexEditor = ({
  layerRef,
  textsRef,
  imagesRef,
  textActive,
  imageActive
}: IProps) => {
  const moveNode = (node: Konva.Shape, up: boolean) => {
    if (!layerRef.current) return;

    const nodes = layerRef.current
      .getChildren()
      .filter(
        (child): child is Konva.Shape =>
          child.getClassName() === 'Text' ||
          child.getClassName() === 'Image' ||
          child.getClassName() === 'Transformer'
      )
      .sort((a, b) => a.getZIndex() - b.getZIndex());

    let currentIndex = nodes.indexOf(node);
    const maxIndex = nodes.length - 1;
    const minIndex = 0;
    let nextNode;

    if (up && currentIndex < maxIndex) {
      while (currentIndex < maxIndex) {
        nextNode = nodes[currentIndex + 1];
        if (
          nextNode.getClassName() === 'Transformer' &&
          nextNode.index < nodes.length
        ) {
          node.moveUp();
          layerRef.current.draw();
          currentIndex++;
        } else {
          break;
        }
      }

      if (nextNode && nextNode.index <= nodes.length) node.moveUp();
    } else if (!up && currentIndex > minIndex) {
      let prevNode;

      while (currentIndex > minIndex) {
        prevNode = nodes[currentIndex - 1];

        if (prevNode.getClassName() === 'Transformer' && prevNode.index > 1) {
          node.moveDown();
          layerRef.current.draw();
          currentIndex--;
        } else {
          break;
        }
      }

      if (prevNode && prevNode.index > 0) node.moveDown();
    }

    layerRef.current.draw();
  };

  const handleMoveUpDown = (up: boolean) => {
    if (textActive !== null && textsRef.current[textActive]) {
      moveNode(textsRef.current[textActive], up);
    }
    if (imageActive !== null && imagesRef.current[imageActive]) {
      moveNode(imagesRef.current[imageActive].konvaImage, up);
    }
  };

  return { handleMoveUpDown };
};

export default useZindexEditor;
